// =============================================================
// 🧑‍💻 OperatorStatusCard.jsx — Status dos operadores
// =============================================================

import React from "react";

export default function OperatorStatusCard({ data }) {
  // Espera um objeto do tipo:
  // { online: number, busy: number, offline: number }
  const online = data?.online || 0;
  const busy = data?.busy || 0;
  const offline = data?.offline || 0;
  const total = online + busy + offline;

  return (
    <div className="ia-kpi-card">
      <div className="ia-kpi-card-header">
        <span className="ia-kpi-label">Status dos operadores</span>
        <span className="ia-kpi-icon">
          <i className="fas fa-headset" />
        </span>
      </div>

      <div className="ia-kpi-main-value">
        {total} operador{total === 1 ? "" : "es"}
      </div>

      <div className="ia-kpi-sub">
        <span className="ia-status-pill ia-status-pill-online">
          <span className="ia-status-dot ia-status-dot-online" />
          {online} online
        </span>

        <span className="ia-status-pill ia-status-pill-busy">
          <span className="ia-status-dot ia-status-dot-busy" />
          {busy} em atendimento
        </span>

        <span className="ia-status-pill ia-status-pill-offline">
          <span className="ia-status-dot ia-status-dot-offline" />
          {offline} offline
        </span>
      </div>
    </div>
  );
} 
